/*
 * Import Global Modules
 */
import '@/bootstrap';
import VueBootstrapper from '@/VueBootstrap';
import cookiesHide from './jQueryApplication/esm/cookies-hide';

/*
 * Main web Application
 */
import App from './VueApplication/App';

import setClassDirective from './VueApplication/Directives/setClassDirective';
import showroomAddressDirective from './VueApplication/Directives/showroomAddressDirective';
/*
 * Init bootLoader
 */
const vueWebBootLoader = new VueBootstrapper();
vueWebBootLoader.addGlobalDirective('set-class', setClassDirective);
vueWebBootLoader.addGlobalDirective('showroom-address', showroomAddressDirective);

/*
 * Start Application
 */
vueWebBootLoader.init(App).mount('#app');
cookiesHide();



// WEBPACK FOOTER //
// ./templates/floor/assets/js/app.js